import { ControllerProps } from "react-hook-form";
import { InputField } from "../InputField";

interface InputSelectProps extends Omit<ControllerProps, "render"> {
  label: string;
  name: string;
}

const InputSelect = (props: InputSelectProps) => {
  const { name, ...rest } = props;

  return (
    <InputField
      inputProps={{ placeholder: "Zip code - City, State" }}
      name={name}
      {...rest}
    />
  );
};

export default InputSelect;


